import { render, staticRenderFns } from "./CircuitBreakerSetting.vue?vue&type=template&id=afb55374&scoped=true"
import script from "./CircuitBreakerSetting.vue?vue&type=script&lang=js"
export * from "./CircuitBreakerSetting.vue?vue&type=script&lang=js"
import style0 from "./CircuitBreakerSetting.vue?vue&type=style&index=0&id=afb55374&prod&lang=scss"
import style1 from "./CircuitBreakerSetting.vue?vue&type=style&index=1&id=afb55374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb55374",
  null
  
)

export default component.exports